// Traducciones para los nuevos dashboards (Admin, Supervisor, Vendedor, Cliente)
export const dashboardTranslations = {
  es: {
    dashboards: {
      admin: {
        title: "Dashboard Administrador",
        subtitle: "Panel de control completo del sistema",
        totalUsers: "Usuarios Totales",
        activeConversations: "Conversaciones Activas",
        monthlyRevenue: "Ingresos Mensuales",
        aiUsage: "Uso de IA",
        totalClients: "Clientes Totales",
        processedMessages: "Mensajes Procesados",
        avgResponseTime: "Tiempo de Respuesta Promedio",
        conversionRate: "Tasa de Conversión",
        channelStatus: "Estado de Canales",
        recentActivity: "Actividad Reciente",
        noRecentActivity: "No hay actividad reciente"
      },
      supervisor: {
        title: "Dashboard Supervisor",
        subtitle: "Supervisión del equipo y rendimiento",
        teamMembers: "Miembros del Equipo",
        activeClients: "Clientes Activos",
        pendingTickets: "Tickets Pendientes",
        resolvedToday: "Resueltos Hoy",
        avgResponseTime: "Tiempo de Respuesta Promedio",
        clientSatisfaction: "Satisfacción del Cliente",
        teamPerformance: "Rendimiento del Equipo",
        recentClients: "Clientes Recientes",
        noTeamMembers: "No hay miembros del equipo",
        teamMembersWillAppear: "Los miembros del equipo aparecerán aquí",
        noClients: "No hay clientes",
        clientsWillAppear: "Los clientes aparecerán aquí cuando lleguen",
        contactAction: "Contactar",
        memberMetrics: {
          activeConversations: "Activas",
          resolved: "Resueltas",
          responseTime: "T. Respuesta"
        },
        table: {
          client: "Cliente",
          contact: "Contacto",
          lastContact: "Último Contacto",
          assignedTo: "Asignado a",
          status: "Estado",
          actions: "Acciones"
        }
      },
      seller: {
        title: "Dashboard Vendedor",
        subtitle: "Gestión de leads y ventas",
        activeLeads: "Leads Activos",
        monthlySales: "Ventas del Mes",
        commission: "Comisiones",
        conversionRate: "Tasa de Conversión",
        totalContacts: "Total de Contactos",
        closedDeals: "Negocios Cerrados",
        quickActions: "Acciones Rápidas",
        newLead: "Nuevo Lead",
        viewAllLeads: "Ver Todos los Leads",
        viewCommissions: "Ver Comisiones",
        myLeads: "Mis Leads",
        noLeads: "No tienes leads",
        startAddingLeads: "Comienza agregando leads para ver tu progreso",
        table: {
          lead: "Lead",
          contact: "Contacto",
          source: "Origen",
          lastContact: "Último contacto",
          status: "Estado",
          actions: "Acciones"
        },
        toasts: {
          openingLead: "Abriendo lead...",
          editingLead: "Editando lead...",
          contactingLead: "Contactando lead..."
        }
      },
      client: {
        title: "Dashboard Cliente",
        subtitle: "Tu panel de gestión personal",
        activeConversations: "Conversaciones Activas",
        myTickets: "Mis Tickets",
        responseTime: "Tiempo de Respuesta",
        resolvedTickets: "Tickets Resueltos",
        quickActions: "Acciones Rápidas",
        createTicket: "Crear Ticket",
        chatWithAI: "Chat con IA",
        contactSupport: "Contactar Soporte",
        myConversations: "Mis Conversaciones",
        noConversations: "No tienes conversaciones activas",
        conversationsWillAppear: "Tus conversaciones aparecerán aquí",
        noTickets: "No tienes tickets",
        createTicketForHelp: "Crea un ticket para obtener ayuda",
        reply: "Responder",
        archive: "Archivar",
        labels: {
          created: "Creado",
          updated: "Actualizado"
        },
        toasts: {
          openingChat: "Abriendo chat...",
          conversationArchived: "Conversación archivada",
          conversationArchiveError: "Error al archivar conversación",
          openingTicket: "Abriendo ticket...",
          editTicketComingSoon: "Edición de ticket próximamente",
          ticketClosed: "Ticket cerrado",
          ticketCloseError: "Error al cerrar ticket",
          subjectMinError: "El asunto debe tener al menos 5 caracteres",
          descriptionMinError: "La descripción debe tener al menos 10 caracteres",
          ticketCreated: "Ticket creado exitosamente",
          ticketCreateError: "Error al crear el ticket"
        },
        fallback: {
          noMessages: "Sin mensajes",
          noSubject: "Sin asunto",
          noDescription: "Sin descripción"
        }
      }
    },
    ticketModal: {
      title: "Crear Nuevo Ticket",
      subject: "Asunto",
      subjectPlaceholder: "Escribe el asunto del ticket",
      description: "Descripción",
      descriptionPlaceholder: "Describe el problema o consulta",
      priority: "Prioridad",
      category: "Categoría",
      createButton: "Crear Ticket",
      cancelButton: "Cancelar"
    },
    priorities: {
      low: "Baja",
      medium: "Media",
      high: "Alta",
      urgent: "Urgente"
    },
    categories: {
      support: "Soporte",
      billing: "Facturación",
      technical: "Técnico",
      general: "General"
    },
    statuses: {
      pending: "Pendiente",
      in_progress: "En Progreso",
      resolved: "Resuelto",
      closed: "Cerrado",
      active: "Activo",
      inactive: "Inactivo",
      online: "En Línea",
      offline: "Desconectado",
      busy: "Ocupado",
      new: "Nuevo",
      contacted: "Contactado",
      qualified: "Calificado",
      converted: "Convertido"
    },
    common: {
      view: "Ver",
      edit: "Editar",
      delete: "Eliminar",
      close: "Cerrar",
      contact: "Contactar",
      error: "Error",
      loading: "Cargando..."
    },
    toasts: {
      viewDetails: "Viendo detalles de {{name}}",
      editItem: "Editando {{name}}",
      contactItem: "Contactando a {{name}}"
    },
    timeAgo: {
      justNow: "Justo ahora"
    }
  },
  en: {
    dashboards: {
      admin: {
        title: "Admin Dashboard",
        subtitle: "Complete system control panel",
        totalUsers: "Total Users",
        activeConversations: "Active Conversations",
        monthlyRevenue: "Monthly Revenue",
        aiUsage: "AI Usage",
        totalClients: "Total Clients",
        processedMessages: "Processed Messages",
        avgResponseTime: "Average Response Time",
        conversionRate: "Conversion Rate",
        channelStatus: "Channel Status",
        recentActivity: "Recent Activity",
        noRecentActivity: "No recent activity"
      },
      supervisor: {
        title: "Supervisor Dashboard",
        subtitle: "Team supervision and performance",
        teamMembers: "Team Members",
        activeClients: "Active Clients",
        pendingTickets: "Pending Tickets",
        resolvedToday: "Resolved Today",
        avgResponseTime: "Average Response Time",
        clientSatisfaction: "Client Satisfaction",
        teamPerformance: "Team Performance",
        recentClients: "Recent Clients",
        noTeamMembers: "No team members",
        teamMembersWillAppear: "Team members will appear here",
        noClients: "No clients",
        clientsWillAppear: "Clients will appear here when they arrive",
        contactAction: "Contact",
        memberMetrics: {
          activeConversations: "Active",
          resolved: "Resolved",
          responseTime: "Resp. Time"
        },
        table: {
          client: "Client",
          contact: "Contact",
          lastContact: "Last Contact",
          assignedTo: "Assigned to",
          status: "Status",
          actions: "Actions"
        }
      },
      seller: {
        title: "Seller Dashboard",
        subtitle: "Lead and sales management",
        activeLeads: "Active Leads",
        monthlySales: "Monthly Sales",
        commission: "Commissions",
        conversionRate: "Conversion Rate",
        totalContacts: "Total Contacts",
        closedDeals: "Closed Deals",
        quickActions: "Quick Actions",
        newLead: "New Lead",
        viewAllLeads: "View All Leads",
        viewCommissions: "View Commissions",
        myLeads: "My Leads",
        noLeads: "You have no leads",
        startAddingLeads: "Start adding leads to see your progress",
        table: {
          lead: "Lead",
          contact: "Contact",
          source: "Source",
          lastContact: "Last contact",
          status: "Status",
          actions: "Actions"
        },
        toasts: {
          openingLead: "Opening lead...",
          editingLead: "Editing lead...",
          contactingLead: "Contacting lead..."
        }
      },
      client: {
        title: "Client Dashboard",
        subtitle: "Your personal management panel",
        activeConversations: "Active Conversations",
        myTickets: "My Tickets",
        responseTime: "Response Time",
        resolvedTickets: "Resolved Tickets",
        quickActions: "Quick Actions",
        createTicket: "Create Ticket",
        chatWithAI: "Chat with AI",
        contactSupport: "Contact Support",
        myConversations: "My Conversations",
        noConversations: "You have no active conversations",
        conversationsWillAppear: "Your conversations will appear here",
        noTickets: "You have no tickets",
        createTicketForHelp: "Create a ticket to get help",
        reply: "Reply",
        archive: "Archive",
        labels: {
          created: "Created",
          updated: "Updated"
        },
        toasts: {
          openingChat: "Opening chat...",
          conversationArchived: "Conversation archived",
          conversationArchiveError: "Error archiving conversation",
          openingTicket: "Opening ticket...",
          editTicketComingSoon: "Ticket editing coming soon",
          ticketClosed: "Ticket closed",
          ticketCloseError: "Error closing ticket",
          subjectMinError: "Subject must be at least 5 characters",
          descriptionMinError: "Description must be at least 10 characters",
          ticketCreated: "Ticket created successfully",
          ticketCreateError: "Error creating the ticket"
        },
        fallback: {
          noMessages: "No messages",
          noSubject: "No subject",
          noDescription: "No description"
        }
      }
    },
    ticketModal: {
      title: "Create New Ticket",
      subject: "Subject",
      subjectPlaceholder: "Enter the ticket subject",
      description: "Description",
      descriptionPlaceholder: "Describe the problem or question",
      priority: "Priority",
      category: "Category",
      createButton: "Create Ticket",
      cancelButton: "Cancel"
    },
    priorities: {
      low: "Low",
      medium: "Medium",
      high: "High",
      urgent: "Urgent"
    },
    categories: {
      support: "Support",
      billing: "Billing",
      technical: "Technical",
      general: "General"
    },
    statuses: {
      pending: "Pending",
      in_progress: "In Progress",
      resolved: "Resolved",
      closed: "Closed",
      active: "Active",
      inactive: "Inactive",
      online: "Online",
      offline: "Offline",
      busy: "Busy",
      new: "New",
      contacted: "Contacted",
      qualified: "Qualified",
      converted: "Converted"
    },
    common: {
      view: "View",
      edit: "Edit",
      delete: "Delete",
      close: "Close",
      contact: "Contact",
      error: "Error",
      loading: "Loading..."
    },
    toasts: {
      viewDetails: "Viewing details of {{name}}",
      editItem: "Editing {{name}}",
      contactItem: "Contacting {{name}}"
    },
    timeAgo: {
      justNow: "Just now"
    }
  },
  pt: {
    dashboards: {
      admin: {
        title: "Dashboard Administrador",
        subtitle: "Painel de controle completo do sistema",
        totalUsers: "Usuários Totais",
        activeConversations: "Conversas Ativas",
        monthlyRevenue: "Receita Mensal",
        aiUsage: "Uso de IA",
        totalClients: "Clientes Totais",
        processedMessages: "Mensagens Processadas",
        avgResponseTime: "Tempo Médio de Resposta",
        conversionRate: "Taxa de Conversão",
        channelStatus: "Status dos Canais",
        recentActivity: "Atividade Recente",
        noRecentActivity: "Sem atividade recente"
      },
      supervisor: {
        title: "Dashboard Supervisor",
        subtitle: "Supervisão da equipe e desempenho",
        teamMembers: "Membros da Equipe",
        activeClients: "Clientes Ativos",
        pendingTickets: "Tickets Pendentes",
        resolvedToday: "Resolvidos Hoje",
        avgResponseTime: "Tempo Médio de Resposta",
        clientSatisfaction: "Satisfação do Cliente",
        teamPerformance: "Desempenho da Equipe",
        recentClients: "Clientes Recentes",
        noTeamMembers: "Sem membros da equipe",
        teamMembersWillAppear: "Membros da equipe aparecerão aqui",
        noClients: "Sem clientes",
        clientsWillAppear: "Clientes aparecerão aqui quando chegarem",
        contactAction: "Contatar",
        memberMetrics: {
          activeConversations: "Ativas",
          resolved: "Resolvidas",
          responseTime: "T. Resposta"
        },
        table: {
          client: "Cliente",
          contact: "Contato",
          lastContact: "Último Contato",
          assignedTo: "Atribuído a",
          status: "Status",
          actions: "Ações"
        }
      },
      seller: {
        title: "Dashboard Vendedor",
        subtitle: "Gestão de leads e vendas",
        activeLeads: "Leads Ativos",
        monthlySales: "Vendas do Mês",
        commission: "Comissões",
        conversionRate: "Taxa de Conversão",
        totalContacts: "Total de Contatos",
        closedDeals: "Negócios Fechados",
        quickActions: "Ações Rápidas",
        newLead: "Novo Lead",
        viewAllLeads: "Ver Todos os Leads",
        viewCommissions: "Ver Comissões",
        myLeads: "Meus Leads",
        noLeads: "Você não tem leads",
        startAddingLeads: "Comece adicionando leads para ver seu progresso",
        table: {
          lead: "Lead",
          contact: "Contato",
          source: "Origem",
          lastContact: "Último contato",
          status: "Status",
          actions: "Ações"
        },
        toasts: {
          openingLead: "Abrindo lead...",
          editingLead: "Editando lead...",
          contactingLead: "Contactando lead..."
        }
      },
      client: {
        title: "Dashboard Cliente",
        subtitle: "Seu painel de gestão pessoal",
        activeConversations: "Conversas Ativas",
        myTickets: "Meus Tickets",
        responseTime: "Tempo de Resposta",
        resolvedTickets: "Tickets Resolvidos",
        quickActions: "Ações Rápidas",
        createTicket: "Criar Ticket",
        chatWithAI: "Chat com IA",
        contactSupport: "Contatar Suporte",
        myConversations: "Minhas Conversas",
        noConversations: "Você não tem conversas ativas",
        conversationsWillAppear: "Suas conversas aparecerão aqui",
        noTickets: "Você não tem tickets",
        createTicketForHelp: "Crie um ticket para obter ajuda",
        reply: "Responder",
        archive: "Arquivar",
        labels: {
          created: "Criado",
          updated: "Atualizado"
        },
        toasts: {
          openingChat: "Abrindo chat...",
          conversationArchived: "Conversa arquivada",
          conversationArchiveError: "Erro ao arquivar conversa",
          openingTicket: "Abrindo ticket...",
          editTicketComingSoon: "Edição de ticket em breve",
          ticketClosed: "Ticket fechado",
          ticketCloseError: "Erro ao fechar ticket",
          subjectMinError: "O assunto deve ter pelo menos 5 caracteres",
          descriptionMinError: "A descrição deve ter pelo menos 10 caracteres",
          ticketCreated: "Ticket criado com sucesso",
          ticketCreateError: "Erro ao criar o ticket"
        },
        fallback: {
          noMessages: "Sem mensagens",
          noSubject: "Sem assunto",
          noDescription: "Sem descrição"
        }
      }
    },
    ticketModal: {
      title: "Criar Novo Ticket",
      subject: "Assunto",
      subjectPlaceholder: "Digite o assunto do ticket",
      description: "Descrição",
      descriptionPlaceholder: "Descreva o problema ou dúvida",
      priority: "Prioridade",
      category: "Categoria",
      createButton: "Criar Ticket",
      cancelButton: "Cancelar"
    },
    priorities: {
      low: "Baixa",
      medium: "Média",
      high: "Alta",
      urgent: "Urgente"
    },
    categories: {
      support: "Suporte",
      billing: "Faturamento",
      technical: "Técnico",
      general: "Geral"
    },
    statuses: {
      pending: "Pendente",
      in_progress: "Em Progresso",
      resolved: "Resolvido",
      closed: "Fechado",
      active: "Ativo",
      inactive: "Inativo",
      online: "Online",
      offline: "Offline",
      busy: "Ocupado",
      new: "Novo",
      contacted: "Contactado",
      qualified: "Qualificado",
      converted: "Convertido"
    },
    common: {
      view: "Ver",
      edit: "Editar",
      delete: "Excluir",
      close: "Fechar",
      contact: "Contatar",
      error: "Erro",
      loading: "Carregando..."
    },
    toasts: {
      viewDetails: "Visualizando detalhes de {{name}}",
      editItem: "Editando {{name}}",
      contactItem: "Contatando {{name}}"
    },
    timeAgo: {
      justNow: "Agora mesmo"
    }
  },
  fr: {
    dashboards: {
      admin: {
        title: "Tableau de bord Administrateur",
        subtitle: "Panneau de contrôle complet du système",
        totalUsers: "Utilisateurs totaux",
        activeConversations: "Conversations actives",
        monthlyRevenue: "Revenu mensuel",
        aiUsage: "Utilisation de l'IA",
        totalClients: "Clients totaux",
        processedMessages: "Messages traités",
        avgResponseTime: "Temps de réponse moyen",
        conversionRate: "Taux de conversion",
        channelStatus: "État des canaux",
        recentActivity: "Activité récente",
        noRecentActivity: "Aucune activité récente"
      },
      supervisor: {
        title: "Tableau de bord Superviseur",
        subtitle: "Supervision de l'équipe et performance",
        teamMembers: "Membres de l'équipe",
        activeClients: "Clients actifs",
        pendingTickets: "Tickets en attente",
        resolvedToday: "Résolus aujourd'hui",
        avgResponseTime: "Temps de réponse moyen",
        clientSatisfaction: "Satisfaction client",
        teamPerformance: "Performance de l'équipe",
        recentClients: "Clients récents",
        noTeamMembers: "Aucun membre d'équipe",
        teamMembersWillAppear: "Les membres de l'équipe apparaîtront ici",
        noClients: "Aucun client",
        clientsWillAppear: "Les clients apparaîtront ici lorsqu'ils arriveront",
        contactAction: "Contacter",
        memberMetrics: {
          activeConversations: "Actives",
          resolved: "Résolues",
          responseTime: "T. Réponse"
        },
        table: {
          client: "Client",
          contact: "Contact",
          lastContact: "Dernier contact",
          assignedTo: "Assigné à",
          status: "Statut",
          actions: "Actions"
        }
      },
      seller: {
        title: "Tableau de bord Vendeur",
        subtitle: "Gestion des prospects et des ventes",
        activeLeads: "Prospects actifs",
        monthlySales: "Ventes du mois",
        commission: "Commissions",
        conversionRate: "Taux de conversion",
        totalContacts: "Total des contacts",
        closedDeals: "Affaires conclues",
        quickActions: "Actions rapides",
        newLead: "Nouveau prospect",
        viewAllLeads: "Voir tous les prospects",
        viewCommissions: "Voir les commissions",
        myLeads: "Mes prospects",
        noLeads: "Vous n'avez aucun prospect",
        startAddingLeads: "Commencez à ajouter des prospects pour voir votre progression",
        table: {
          lead: "Prospect",
          contact: "Contact",
          source: "Source",
          lastContact: "Dernier contact",
          status: "Statut",
          actions: "Actions"
        },
        toasts: {
          openingLead: "Ouverture du prospect...",
          editingLead: "Modification du prospect...",
          contactingLead: "Contact du prospect..."
        }
      },
      client: {
        title: "Tableau de bord Client",
        subtitle: "Votre tableau de gestion personnel",
        activeConversations: "Conversations actives",
        myTickets: "Mes tickets",
        responseTime: "Temps de réponse",
        resolvedTickets: "Tickets résolus",
        quickActions: "Actions rapides",
        createTicket: "Créer un ticket",
        chatWithAI: "Discuter avec l'IA",
        contactSupport: "Contacter le support",
        myConversations: "Mes conversations",
        noConversations: "Vous n'avez aucune conversation active",
        conversationsWillAppear: "Vos conversations apparaîtront ici",
        noTickets: "Vous n'avez aucun ticket",
        createTicketForHelp: "Créez un ticket pour obtenir de l'aide",
        reply: "Répondre",
        archive: "Archiver",
        labels: {
          created: "Créé",
          updated: "Mis à jour"
        },
        toasts: {
          openingChat: "Ouverture du chat...",
          conversationArchived: "Conversation archivée",
          conversationArchiveError: "Erreur lors de l'archivage de la conversation",
          openingTicket: "Ouverture du ticket...",
          editTicketComingSoon: "Modification du ticket bientôt disponible",
          ticketClosed: "Ticket fermé",
          ticketCloseError: "Erreur lors de la fermeture du ticket",
          subjectMinError: "Le sujet doit contenir au moins 5 caractères",
          descriptionMinError: "La description doit contenir au moins 10 caractères",
          ticketCreated: "Ticket créé avec succès",
          ticketCreateError: "Erreur lors de la création du ticket"
        },
        fallback: {
          noMessages: "Aucun message",
          noSubject: "Sans sujet",
          noDescription: "Sans description"
        }
      }
    },
    ticketModal: {
      title: "Créer un nouveau ticket",
      subject: "Sujet",
      subjectPlaceholder: "Saisissez l'objet du ticket",
      description: "Description",
      descriptionPlaceholder: "Décrivez le problème ou la demande",
      priority: "Priorité",
      category: "Catégorie",
      createButton: "Créer un ticket",
      cancelButton: "Annuler"
    },
    priorities: {
      low: "Faible",
      medium: "Moyenne",
      high: "Élevée",
      urgent: "Urgente"
    },
    categories: {
      support: "Support",
      billing: "Facturation",
      technical: "Technique",
      general: "Général"
    },
    statuses: {
      pending: "En attente",
      in_progress: "En cours",
      resolved: "Résolu",
      closed: "Fermé",
      active: "Actif",
      inactive: "Inactif",
      online: "En ligne",
      offline: "Hors ligne",
      busy: "Occupé",
      new: "Nouveau",
      contacted: "Contacté",
      qualified: "Qualifié",
      converted: "Converti"
    },
    common: {
      view: "Voir",
      edit: "Modifier",
      delete: "Supprimer",
      close: "Fermer",
      contact: "Contacter",
      error: "Erreur",
      loading: "Chargement..."
    },
    toasts: {
      viewDetails: "Affichage des détails de {{name}}",
      editItem: "Modification de {{name}}",
      contactItem: "Contact avec {{name}}"
    },
    timeAgo: {
      justNow: "À l'instant"
    }
  },
  it: {
    dashboards: {
      admin: {
        title: "Dashboard Amministratore",
        subtitle: "Pannello di controllo completo del sistema",
        totalUsers: "Utenti totali",
        activeConversations: "Conversazioni attive",
        monthlyRevenue: "Ricavi mensili",
        aiUsage: "Uso dell'IA",
        totalClients: "Clienti totali",
        processedMessages: "Messaggi elaborati",
        avgResponseTime: "Tempo medio di risposta",
        conversionRate: "Tasso di conversione",
        channelStatus: "Stato dei canali",
        recentActivity: "Attività recente",
        noRecentActivity: "Nessuna attività recente"
      },
      supervisor: {
        title: "Dashboard Supervisore",
        subtitle: "Supervisione del team e prestazioni",
        teamMembers: "Membri del team",
        activeClients: "Clienti attivi",
        pendingTickets: "Ticket in sospeso",
        resolvedToday: "Risolti oggi",
        avgResponseTime: "Tempo medio di risposta",
        clientSatisfaction: "Soddisfazione del cliente",
        teamPerformance: "Prestazioni del team",
        recentClients: "Clienti recenti",
        noTeamMembers: "Nessun membro del team",
        teamMembersWillAppear: "I membri del team appariranno qui",
        noClients: "Nessun cliente",
        clientsWillAppear: "I clienti appariranno qui quando arriveranno",
        contactAction: "Contatta",
        memberMetrics: {
          activeConversations: "Attive",
          resolved: "Risolte",
          responseTime: "T. Risposta"
        },
        table: {
          client: "Cliente",
          contact: "Contatto",
          lastContact: "Ultimo contatto",
          assignedTo: "Assegnato a",
          status: "Stato",
          actions: "Azioni"
        }
      },
      seller: {
        title: "Dashboard Venditore",
        subtitle: "Gestione lead e vendite",
        activeLeads: "Lead attivi",
        monthlySales: "Vendite del mese",
        commission: "Commissioni",
        conversionRate: "Tasso di conversione",
        totalContacts: "Totale contatti",
        closedDeals: "Affari chiusi",
        quickActions: "Azioni rapide",
        newLead: "Nuovo lead",
        viewAllLeads: "Vedi tutti i lead",
        viewCommissions: "Vedi commissioni",
        myLeads: "I miei lead",
        noLeads: "Non hai lead",
        startAddingLeads: "Inizia ad aggiungere lead per vedere i tuoi progressi",
        table: {
          lead: "Lead",
          contact: "Contatto",
          source: "Origine",
          lastContact: "Ultimo contatto",
          status: "Stato",
          actions: "Azioni"
        },
        toasts: {
          openingLead: "Apertura lead...",
          editingLead: "Modifica lead...",
          contactingLead: "Contatto lead..."
        }
      },
      client: {
        title: "Dashboard Cliente",
        subtitle: "Il tuo pannello di gestione personale",
        activeConversations: "Conversazioni attive",
        myTickets: "I miei ticket",
        responseTime: "Tempo di risposta",
        resolvedTickets: "Ticket risolti",
        quickActions: "Azioni rapide",
        createTicket: "Crea ticket",
        chatWithAI: "Chat con IA",
        contactSupport: "Contatta supporto",
        myConversations: "Le mie conversazioni",
        noConversations: "Non hai conversazioni attive",
        conversationsWillAppear: "Le tue conversazioni appariranno qui",
        noTickets: "Non hai ticket",
        createTicketForHelp: "Crea un ticket per ottenere aiuto",
        reply: "Rispondi",
        archive: "Archivia",
        labels: {
          created: "Creato",
          updated: "Aggiornato"
        },
        toasts: {
          openingChat: "Apertura chat...",
          conversationArchived: "Conversazione archiviata",
          conversationArchiveError: "Errore durante l'archiviazione della conversazione",
          openingTicket: "Apertura ticket...",
          editTicketComingSoon: "Modifica ticket in arrivo",
          ticketClosed: "Ticket chiuso",
          ticketCloseError: "Errore durante la chiusura del ticket",
          subjectMinError: "L'oggetto deve contenere almeno 5 caratteri",
          descriptionMinError: "La descrizione deve contenere almeno 10 caratteri",
          ticketCreated: "Ticket creato con successo",
          ticketCreateError: "Errore durante la creazione del ticket"
        },
        fallback: {
          noMessages: "Nessun messaggio",
          noSubject: "Senza oggetto",
          noDescription: "Senza descrizione"
        }
      }
    },
    ticketModal: {
      title: "Crea nuovo ticket",
      subject: "Oggetto",
      subjectPlaceholder: "Inserisci l'oggetto del ticket",
      description: "Descrizione",
      descriptionPlaceholder: "Descrivi il problema o la richiesta",
      priority: "Priorità",
      category: "Categoria",
      createButton: "Crea ticket",
      cancelButton: "Annulla"
    },
    priorities: {
      low: "Bassa",
      medium: "Media",
      high: "Alta",
      urgent: "Urgente"
    },
    categories: {
      support: "Supporto",
      billing: "Fatturazione",
      technical: "Tecnico",
      general: "Generale"
    },
    statuses: {
      pending: "In attesa",
      in_progress: "In corso",
      resolved: "Risolto",
      closed: "Chiuso",
      active: "Attivo",
      inactive: "Inattivo",
      online: "Online",
      offline: "Offline",
      busy: "Occupato",
      new: "Nuovo",
      contacted: "Contattato",
      qualified: "Qualificato",
      converted: "Convertito"
    },
    common: {
      view: "Visualizza",
      edit: "Modifica",
      delete: "Elimina",
      close: "Chiudi",
      contact: "Contatta",
      error: "Errore",
      loading: "Caricamento..."
    },
    toasts: {
      viewDetails: "Visualizzazione dei dettagli di {{name}}",
      editItem: "Modifica di {{name}}",
      contactItem: "Contattando {{name}}"
    },
    timeAgo: {
      justNow: "Proprio ora"
    }
  }
};
